module.exports = __webpack_public_path__ + "img/shuangyue.a9dc2e99.png";